import axios from "axios";
import {
  levels2Requested,
  levels2RequestFailed,
  levels2RequestSucceeded,
} from "../slices/GetLevels2Slice";

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const GetLevels2 = () => async (dispatch) => {
  try {
    dispatch(levels2Requested());

    const selectedCountry = localStorage.getItem("selectedCountry");
    const apiUrl = `${
      process.env.REACT_APP_BASE_API_URL
    }/api/Menu/GetLevels2ByCountry?country=${encodeURIComponent(selectedCountry)}`;

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);

    if (!Array.isArray(response.data)) {
      const errorMessage =
        typeof response.data === "string"
          ? response.data
          : "There was an error loading the data";
      dispatch(levels2RequestFailed(errorMessage));
      return;
    }

    dispatch(levels2RequestSucceeded(response.data));
  } catch (error) {
    dispatch(levels2RequestFailed(error.message));
  }
};
